import { MessageCircle } from "lucide-react";
import { CONFIG } from "@/lib/api";

export default function FloatingWhatsApp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={`https://wa.me/${CONFIG.whatsapp}?text=${encodeURIComponent("Hi, I'm interested in Provident Winworth Edappally, Kochi. Please share more details.")}`}
      target="_blank"
      rel="noreferrer"
      className="hidden md:flex fixed bottom-6 right-6 z-40 items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-2xl"
      style={{ background: "var(--pcv-wa)", color: "#fff" }}
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-xs uppercase tracking-[0.16em] font-medium">WhatsApp</span>
    </a>
  );
}
